export enum WIPMode {
    Pencil = 'pencil',
    Eraser = 'eraser',
    Type = 'type',
    Hand = 'hand',
    Resize = 'resize',
    Line = 'line'
}
